export type Breadcrumb = {
  name: string;
  link?: string[];
}
